import OrgScopedPage from "./OrgScopedPage";
import ConversationManager from "../ConversationManager/ConversationManager";

/**
 * PlatformConversations — super-admin Customer Conversations page. Reuses the
 * exact tenant Conversation Manager (table of name / email / chat history)
 * scoped to the selected organization.
 */
export default function PlatformConversations() {
    return (
        <OrgScopedPage title="Customer Conversations" subtitle="View an organization's customer chats, names and emails.">
            <ConversationManager />
        </OrgScopedPage>
    );
}
